module.exports = __webpack_public_path__ + "img/1home-360.0305b1b8.svg";